import React from "react"

import design from "../images/icons/design.svg"
import development from "../images/icons/development.svg"
import ecommerce from "../images/icons/e-commerce.svg"

const OtherServices = () => (
  <div id="other" className="section light">
    <div className="container">
      <div className="row sectonTitle">
        <div className="col">
          <h2>Our Specializations</h2>
        </div>
      </div>
      <div className="row sectonContent">
        <div className="col-md-4 iconBlock">
          <div className="row">
            <div className="col">
              <img alt="design" className="iconLarge" src={design} />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <h4>Web Design</h4>
            </div>
          </div>
          <p className="sectionText">
            <b>
              Websites {"\u2022"} Application {"\u2022"} Logos
            </b>
          </p>
        </div>
        <div className="col-md-4 iconBlock">
          <div className="row">
            <div className="col">
              <img alt="development" className="iconLarge" src={development} />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <h4>Web Development</h4>
            </div>
          </div>
          <p className="sectionText">
            <b>
              Programming {"\u2022"} Hosting {"\u2022"} Maintenance
            </b>
          </p>
        </div>
        <div className="col-md-4 iconBlock">
          <div className="row">
            <div className="col">
              <img alt="Cart" className="iconLarge" src={ecommerce} />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <h4>E-Commerce</h4>
            </div>
          </div>
          <p className="sectionText">
            <b>
              Stripe {"\u2022"} Shopify {"\u2022"} Custom Stores
            </b>
          </p>
        </div>
      </div>
    </div>
  </div>
)

export default OtherServices
